<template>
    <div class="tabbar-content">
        <div class="tabbar">
            <div v-if="!isShowSport" class="item" :class="{ 'act': actIdx == 2 }" @click.stop="change(2)">
                <van-icon name="apps-o" />
                <div class="item-text">{{ $t("tabbar.menu") }}</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 1 }" @click.stop="change(1)">
                <van-icon name="wap-home-o" />
                <div class="item-text">{{ $t("tabbar.Lobby") }}</div>
            </div>
            <div v-if="isShowSport" class="item" :class="{ 'act': actIdx == 2 }" @click.stop="toSports">
                <van-icon :name="require('@/assets/common/zuqiu.png')" />
                <div class="item-text">{{ $t("tabbar.sport") }}</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 3 }" @click.stop="change(3)">
                <van-icon name="friends-o" />
                <div class="item-text">{{ $t("tabbar.Affiliate") }}</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 4 }" @click.stop="change(4)">
                <van-icon name="diamond-o" />
                <div class="item-text">VIP</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 5 }" @click.stop="change(5)">
                <van-icon name="contact-o" />
                <div class="item-text">{{ $t("tabbar.Account") }}</div>
            </div>
        </div>
        <!-- <div v-if="isShowSaveVersion" class="pwa" @click="onShowSaveVersionPopup">
            <div class="iconfont icon-jiahao"></div>
            <div class="txt">{{ $t('downApp.SaveVersionDesktop') }}</div>
            <div class="iconfont icon-s-cuowu-guanbi" @click.stop="onCloseSaveVersion"></div>
        </div> -->
        <pwaIosPopup ref="pwaIosPopup" :isToHome="false"></pwaIosPopup>
        <SaveVersionPopup ref="SaveVersionPopup" :isToHome="false"></SaveVersionPopup>
        <div style="height: 1.24rem"></div>
    </div>
</template>

<script>
import pwaIosPopup from '@/views/downAppPWA/modules/pwaIosPopup'
import SaveVersionPopup from '@/views/downAppPWA/modules/SaveVersionPopup'
import { isPWA, getPlatform } from '@/utils'
export default {
    name: 'Tabbar',
    components: { pwaIosPopup, SaveVersionPopup },
    data() {
        return {
            actIdx: 1,
            isSaveVersionDesktop: true
        }
    },
    computed: {
        isShowSport() {
            if (this.$store.getters.userInfo.memberType === 'virtually') return false
            const msg = this.$store.state.system.betSportMsg
            return msg?.brandId !== null && msg?.gameInfoId !== null
        },
        isShowSaveVersion() {
            return this.$store.state.system.isSaveVersionDesktop === 1 && this.isSaveVersionDesktop && (!isPWA()) && getPlatform() !== 'android' && getPlatform() !== 'Android'
        }
    },
    created() {
        const path = this.$route.path
        if (path === '/Home') {
            this.actIdx = 1
        }
        if (path === '/Affiliate') {
            this.actIdx = 3
        }
        if (path === '/vip') {
            this.actIdx = 4
        }
        if (path === '/Person') {
            this.actIdx = 5
        }
    },
    watch: {
        $route: {
            handler: function (to, from) {
                const path = this.$route.path
                if (path === '/Home') {
                    this.actIdx = 1
                } else if (path === '/Affiliate') {
                    this.actIdx = 3
                } else if (path === '/vip') {
                    this.actIdx = 4
                } else if (path === '/Person') {
                    this.actIdx = 5
                } else {
                    this.actIdx = -1
                }
            },
            deep: true
        }
    },
    methods: {
        toSports() {
            this.onNavTo({ url: 'Sports' })
        },
        change(idx) {
            if (this.actIdx === idx) return
            if (idx === 1) {
                this.onNavTo({ url: '/Home', replace: 1 })
                this.actIdx = idx
            } else if (idx === 2) {
                this.$store.dispatch('app/toggleSideBar')
            } else if (idx === 3) {
                this.onNavTo({ url: '/Affiliate', replace: 1 })
                this.actIdx = idx
            } else if (idx === 4) {
                this.onTabbarLoginNav({ url: '/vip', idx })
            } else if (idx === 5) {
                this.onTabbarLoginNav({ url: '/Person', idx })
            }
        },
        onTabbarLoginNav({ url, idx }) {
            if (!this.$store.getters.token) {
                this.$store.dispatch('user/changeLoginType', 2)
                this.$store.dispatch('user/setIsShowLoginPopup', true)
                return
            }
            this.onNavTo({ url, replace: 1 })
            this.actIdx = idx
        },
        onCloseSaveVersion() {
            this.isSaveVersionDesktop = false
        },
        onShowSaveVersionPopup() {
            this.isSaveVersionDesktop = false
            if (getPlatform() === 'ios') {
                this.$refs.pwaIosPopup.open()
            } else {
                this.$refs.SaveVersionPopup.open()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/common/styles/viriables.scss';

html[data-device-nodesktop="1"] {
    .tabbar {
        display: none;
    }

    .tabbar-content {
        display: none;
    }
}

html[data-device-nodesktop="0"] {
    .tabbar {
        max-width: 100%;
    }

    .tabbar-content {
        max-width: 100%;
    }
}

.tabbar-content {
    position: relative;

    .pwa {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 101;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: .62rem;
        padding: 0 .26rem;
        background: $bg-tabbar-float-color;
        border-top: 1px solid $border-tabbar-divider-color;
        color: $font-accent-color;
        font-size: .34rem;
        line-height: .34rem;
        box-shadow: 0 -.06rem .18rem rgba($bg-shell-color, .22);
    }
}

.tabbar {
    position: fixed;
    bottom: 0;
    z-index: 100;
    width: 100%;
    height: 1.24rem;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: $bg-tabbar-shell-color;
    border-top: 1px solid $border-tabbar-divider-color;
    filter: drop-shadow(0 -.08rem .18rem rgba($bg-shell-color, .34));

    .item {
        position: relative;
        width: 20%;
        height: 100%;
        overflow: visible;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        cursor: pointer;
        padding-top: .08rem;
        padding-bottom: .2rem;

        ::v-deep .van-icon {
            font-size: .48rem;
            color: $font-tabbar-color;
            transition: color .2s ease;
        }

        .item-text {
            position: relative;
            z-index: 1;
            width: 100%;
            height: .24rem;
            margin-top: .08rem;
            line-height: .24rem;
            text-align: center;
            font-size: .24rem;
            color: $font-tabbar-color;
            transition: color .2s ease;
        }

        &.act {
            ::v-deep .van-icon {
                color: $font-tabbar-active-color;
                text-shadow: 0 0 .18rem rgba($font-theme-color, .2);
            }

            .item-text {
                color: $font-tabbar-active-color;
                text-shadow: 0 0 .18rem rgba($font-theme-color, .16);
            }

            &.center {
                .center-img {
                    .center-inset {
                        border: 1px solid rgba($font-label-color, .54);
                        background: $bg-tabbar-center-color;
                    }
                }
            }
        }

        &.center {
            .center-img {
                position: absolute;
                top: -.12rem;
                left: calc(50% - .6rem);
                width: 1.2rem;
                height: 1.2rem;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                background: $bg-shell-subpanel-color;
                box-shadow: 0 -.08rem .18rem rgba($bg-shell-color, .24);

                .center-inset {
                    width: .95rem;
                    height: .95rem;
                    padding-bottom: .05rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid rgba($font-label-color, .38);
                    border-radius: 50%;
                    background: linear-gradient(180deg, rgba($font-label-color, .22) 0%, rgba($font-label-color, 0) .18rem), $bg-btn-color;
                }
            }
        }
    }
}
</style>
